export const cnFraMasterKey = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A/C", value: "Adjustments made/test complete-equipment in satisfactory condition." },
  {
    key: "R/C",
    value: "Repair or replacement/test complete-equipment in satisfactory condition.",
  },
  { key: "N", value: "Not Tested." },
  { key: "N/A", value: "Test Not Applicable." },
];



// WEBPACK FOOTER //
// ./src/components/Reports/CN/cnFraMasterKeys.js